<template>
  <div>
    <button @click="showModal = true"
            class="btn btn-primary text-white hover:text-gray-200">Periods
    </button>
    <modal :showModal="showModal" @close="showModal = false" classSize="lg:max-w-4xl">
      <div class="mt-3 sm:mt-5">
        <h3 class="text-xl leading-6 font-medium text-gray-900" id="modal-headline">
          Periods
        </h3>
        <table class="min-w-full divide-y divide-gray-200 mt-5">
          <thead>
          <tr>
            <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Period
            </th>
            <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Invoice
            </th>
            <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Amount
            </th>
            <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Paid at
            </th>
          </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="pr in this.prs">
            <td class="px-6 py-4 whitespace-no-wrap text-left ">
              <div class="text-sm leading-5 text-gray-900">
                {{ formatDate(pr.period.start_date) }} to {{ formatDate(pr.period.end_date) }}
              </div>
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-left ">
              <div class="text-sm leading-5 text-gray-900">
                {{ pr.key }}
              </div>
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-left ">
              <div class="text-sm leading-5 text-gray-900">
                {{ pr.total_earnings * 0.01 }}
              </div>
            </td>
            <td class="px-6 py-4 whitespace-no-wrap text-left ">
              <div v-if="pr.status === 'paid'" class="text-sm leading-5 text-gray-900">
                {{ formatDate(pr.paid_at) }}
              </div>
              <div v-else-if="pr.status === 'processing'" class="text-sm leading-5 text-gray-900">
                Processing...
              </div>
              <div v-else class="text-sm leading-5">
                <button type="button"
                        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        @click="markAsPaid(pr)">Mark as paid
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </modal>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: "periods-button",
  props: ['periodReferrers'],
  data: function () {
    return {
      showModal: false,
      authenticity_token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      prs: this.periodReferrers
    }
  },
  methods: {
    markAsPaid(pr) {
      pr.status = "processing";
      axios.post('referrers/'+pr.referrer_id+'/mark_as_paid', {
            period_id: pr.period.id,
            authenticity_token: this.authenticity_token
          },
          {headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}}).then(response => {
        if (response.status === 200) {
          pr.paid_at = response.data.data.paid_at;
          pr.status = response.data.data.status
        }else{
          pr.status = "pending";
        }

      }).catch((response) => {
        pr.status = "pending";
      });
    },
    formatDate(date){
      const formattedDate = new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
      return formattedDate;

    }
  }
}
</script>

<style scoped>

</style>
